export default __webpack_public_path__ + "static/media/bookmagic.3872a223.png";